export const INCLUDE_KEYWORDS_LIMIT = 15;
export const EXCLUDE_KEYWORDS_LIMIT = 15;
export const KEYWORD_LENGTH_LIMIT = 50;
